/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmUrovenPristupuOsoby extends GContentBase<SeznamAdmUrovenPristupuOsobyObj> {
        private seznamObj: SeznamAdmUrovenPristupuOsobyObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmUrovenPristupuOsobyObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmUrovenPristupuOsobyNew",
                contentCaption: "jres:33000693", //RC 33000693 : �rovn� p��stupu osoby
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_ref_txt} - {st_utaj_id_txt}"
                },
                gridSettings: {
                    columnOrder: "ixs_ref_txt,st_utaj_id_txt,dat_zmena,zmenu_prov_txt,dat_od,dat_do,rezim_nakl_txt,stupen_utaj_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmUrovenPristupuOsobyObj extends GAdmSeznamBase {
        ixs_ref: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmUrovenPristupuOsoby", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmUrovenPristupuOsoby",
                newRecord: isNew,
                ixs_ref: isNew == true ? ((this.ixs_ref) ? this.ixs_ref : null) : data.ixs_ref,
                st_utaj_id: isNew == true ? null : data.st_utaj_id,
                dat_od: isNew == true ? null : data.dat_od
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131110").addField("gselectbox", Gordic.Prefabs.Select.ginsref(), {
                name: "ixs_ref",
                model: "model.ixs_ref=value.ixs_ref",
                dropdown: true,
                disabled: this.ixs_ref ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_ref)
                hardFilter["ixs_ref"] = this.ixs_ref;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_ref)
                data["ixs_ref"] = this.ixs_ref
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmUrovenPristupuOsoby.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.ixs_ref, data.st_utaj_id, data.dat_od),
                nazev: "{0} x {1} x{2}".format(data["ixs_ref_txt"], data["st_utaj_id_txt"], data["dat_od"])
            }
        }
    }
}